import React from 'react';
import _SupportInfoContainer from './_SupportInfoContainer.scss';
import {ArticleItem} from 'components/home/sub-view/Article';
import {Articles} from 'api';
import {Link, withRouter} from 'react-router-dom';

class SupportInfoContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    return (
      <div className="wrap-support-container">
        <div className='item-support-container'>
          <div className='wrap-image-support-container'>
            <Link to='cms/vitrade-va-cach-vn-hanh' className='img-link'>
              <img className='image-support-container' src={require('assets/images/footer/image-1.jpg')} alt=''/>
            </Link>
          </div>
          <h3 className='title-black'><Link to='#' className='title-link'>KẾT NỐI CỘNG ĐỒNG DOANH NGHIỆP</Link></h3>
          {/* <p className='support-container-description'>Nunc facilisis eu enim non sodales Nunc facilisis eu enim non sodales</p> */}
        </div>

        <div className='item-support-container'>
          <div className='wrap-image-support-container'>
            <Link to='cms/tr-thanh-vitrader' className='img-link'>
              <img className='image-support-container' src={require('assets/images/footer/image-2.jpg')} alt=''/>
            </Link>
          </div>
          <h3 className='title-black'><Link to='#' className='title-link'>HỖ TRỢ TƯ VẤN DOANH NGHIỆP</Link></h3>
          {/* <p className='support-container-description'>Nunc facilisis eu enim non sodales Nunc facilisis eu enim non sodales</p> */}
        </div>

        <div className='item-support-container'>
          <div className='wrap-image-support-container'>
            <Link to='cms/tr-thanh-vitrader' className='img-link'>
              <img className='image-support-container' src={require('assets/images/footer/image-3.jpg')} alt=''/>
            </Link>
          </div>
          <h3 className='title-black'><Link to='#' className='title-link'>BẢO MẬT THÔNG TIN</Link></h3>
          {/* <p className='support-container-description'>Nunc facilisis eu enim non sodales Nunc facilisis eu enim non sodales</p> */}
        </div>

        <div className='item-support-container'>
          <div className='wrap-image-support-container'>
            <Link to='cms/nha-cung-cp-uy-tin' className='img-link'>
              <img className='image-support-container' src={require('assets/images/footer/image-4.jpg')} alt=''/>
            </Link>
          </div>
          <h3 className='title-black'><Link to='#' className='title-link'>GIẢI PHÁP CNTT HIỆU QUẢ</Link></h3>
          {/* <p className='support-container-description'>Nunc facilisis eu enim non sodales Nunc facilisis eu enim non sodales</p> */}
        </div>
      </div>
    );
  }
}

export default withRouter(SupportInfoContainer);



// WEBPACK FOOTER //
// ./components/home/sub-view/SupportInfoContainer.jsx